import { type IAdminHeaderCompactLayoutProps } from '@framework/theme/admin/AdminHeaderCompactLayout.tsx';
import { FrontHeaderCompactLayout } from '../front/FrontHeaderCompactLayout.tsx';

/**
 * Header del layout fullscreen per BO e Admin: stessa fascia del frontoffice.
 */
export function AdminHeaderCompactLayout(
  props: IAdminHeaderCompactLayoutProps,
) {
  return <FrontHeaderCompactLayout {...props} />;
}
